import React, { Component } from 'react';
import { ValidationModal } from '../components/index';
import '../css/validations.css'
import { connect } from 'react-redux';
import { DISPATCH_ID } from '../libs/utils/Const'

class DepositModal extends Component {
    //#region ######### CHANGES FUNCTIONS AND REFRESH MODEL ###################################################

    RefreshModel = (depositModel) => {
        const { DepositTools } = this.props
        DepositTools.RefreshModel(depositModel);
    }

    OnchangeOrigin = async (event) => {
        const { DepositTools } = this.props
        const index = event.target.value;
        DepositTools.depositModel.orginCode =  DepositTools.AvailablePayments[index].AcctCode;
        DepositTools.depositModel.originName =  DepositTools.AvailablePayments[index].AcctName;
        DepositTools.depositModel.originIndex = index; 
        this.RefreshModel(DepositTools.depositModel);

    }

    FindTheNameByAcctCodePayMethods = async (code) => {
        const { DepositTools } = this.props
        const found = await DepositTools.AvailablePayments.find(element => element.AcctCode === code);
        if (found) {
            return found.AcctName
        } else {
            return 'XXXXX'
        }
    }

    FindTheNameByAcctCode = async (code) => {
        const { DepositTools } = this.props
        const found = await DepositTools.accounts.find(element => element.GLAccount === code);
        if (found) {
            return found.AcctName
        } else {
            return 'XXXXX'
        }

    }

    OnchangeDestination = async (value) => {
        const { DepositTools } = this.props
        DepositTools.depositModel.destinationCode = value;
        DepositTools.depositModel.destinationName = await this.FindTheNameByAcctCode(value);
        this.RefreshModel(DepositTools.depositModel)
    }

    OnchangeDescription = (value) => {
        const { DepositTools } = this.props
        DepositTools.depositModel.description = value;
        this.RefreshModel(DepositTools.depositModel)
    }

    OnchangeAmount = (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { DepositTools } = this.props
        if (isNaN(value)) {
            showAlert({ type: "info", message: `INGRESA UN NÚMERO VALIDO` });
            return;
        }
        DepositTools.depositModel.amount = value;
        this.RefreshModel(DepositTools.depositModel)
    }
    //#endregion

    render() {
        const { DepositTools } = this.props
        return (
            <>
                <div className="modal fade" id="depositModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="depositModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ boxShadow: "1px 1px 10px rgba(1,1,1,0.3)" }}>
                            <div className="modal-body" id="grupo__amountIn">
                                <h4>Depósito</h4>
                                <div className="input-group pl-5 pr-5 mb-3 mt-4">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1" style={{ backgroundColor: "#28a745", borderColor: "#28a745", color: "#fff" }}><strong>$</strong></span>
                                    </div>
                                    <input type="text" className="form-control" placeholder='Monto'
                                        value={DepositTools.depositModel.amount}
                                        onChange={(event) => this.OnchangeAmount(event.target.value)}
                                    />
                                    <select className="input-group-append form-control"
                                        style={{ backgroundColor: "#3c443e0f" }}
                                        value={DepositTools && DepositTools.depositModel.originIndex}
                                        onChange={(event) => this.OnchangeOrigin(event)}>
                                        <option selected value=''>TIPO DE PAGO</option>
                                        {DepositTools && DepositTools.AvailablePayments.length > 0 &&
                                            DepositTools.AvailablePayments.map((payMethod, index) => {
                                                return (
                                                    <option key={index} value={index} >{payMethod.name}- {payMethod.AcctName}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                                <div id="grupo__account" className='mb-3'>
                                    <div className="input-group pl-5 pr-5">
                                        <select className="form-control  text-center"
                                            style={{ backgroundColor: "#3c443e0f" }}
                                            value={!!DepositTools && DepositTools.depositModel.destinationCode}
                                            onChange={(event) => this.OnchangeDestination(event.target.value)}
                                        >
                                            <option value=''>CUENTA DESTINO</option>
                                            {!!DepositTools && DepositTools.accounts.length > 0 &&
                                                DepositTools.accounts.map((acct, index) => {
                                                    return (
                                                        <option key={index} value={acct.GLAccount || acct.AcctCode}>{acct.Account}-{acct.AcctName}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div id="grupo__descriptionIn">
                                    <div className="input-group pl-5 pr-5">
                                        <textarea
                                            maxLength={50}                                            
                                            id="descriptionIn"
                                            className="form-control form__input"
                                            aria-label="With textarea"
                                            placeholder="Descripción"
                                            value={!!DepositTools && DepositTools.depositModel.description}
                                            onChange={(event) => this.OnchangeDescription(event.target.value)}
                                        />
                                    </div>
                                </div>
                                <p className="form__input-error ml-5">Solo números de max. 6 dígitos.</p>
                                <p className="form__input-void ml-5">Ningún campo puede ir vació.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => DepositTools.CleanForm()}>Cancelar</button>
                                <button type="button" className="btn btn-success" onClick={() => DepositTools.AddToLines()}>
                                    <i className="fa fa-plus-circle mr-2" aria-hidden="true" />Hacer depósito
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ValidationModal
                    idValidation="vmDeposit"
                    message={"Ingrese su clave de autorización"}
                    idModalOrigin="#depositModal"
                    eventOnclick={() => {}} />
            </>
        );
    }
}
const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DepositModal);